import { combineReducers } from '@reduxjs/toolkit';
import layout from './layout';
import cartReducer from './cartslice';
import dineInCartReducer from './dineInCartSlice';

const rootReducer = combineReducers({
  layout,
  cart: cartReducer,
  dineInCart: dineInCartReducer,
});

export default rootReducer;
